import React from 'react';
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';
import { ApplicationEnum } from '@lon/shared/enums';
import { ErrorBoundary } from '@lon/shared/pages';
import { ThemeProvider } from './ThemeProvider';
import { AdoptionLogin } from './adoption-login';
import App, { AppPreview } from './app';
import RedirectToLogin from './redirect';
import RegistrationMain from './registration';

const AppRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<ErrorBoundary application={ApplicationEnum.LOGIN} />}>
      <Route element={<ThemeProvider />}>
        <Route path="/mathnation/login" element={<App />}>
          <Route path="*" element={<div />} />
        </Route>
        <Route
          path="/mathnation/login/:stateCode/preview"
          element={<RedirectToLogin />}
        />
        <Route
          path="/mathnation/login/preview/:urlCode?"
          element={<AppPreview />}
        />
        <Route
          path="/mathnation/login/preview/registration"
          element={<RegistrationMain />}
        />
        <Route
          path="/mathnation/login/review/:eventCode"
          element={<AdoptionLogin />}
        />
        <Route
          path="/mathnation/login/adoption/registration"
          element={<RegistrationMain isAdoption />}
        />
      </Route>
    </Route>
  )
);

export default AppRouter;
